// src/components/AnimatedTrophy.jsx

import '../styles/AnimatedTrophy.css'; // سنقوم بإنشاء هذا الملف في الخطوة التالية

const AnimatedTrophy = () => {
  return (
    <div className="trophy-container">
      <svg className="trophy-svg" viewBox="0 0 100 100">
        <g className="trophy-body">
          {/* The cup part */}
          <path d="M30,30 C30,15 70,15 70,30 L70,50 C85,50 85,70 70,70 L30,70 C15,70 15,50 30,50 Z" />
          {/* The base */}
          <path d="M35,70 L35,80 C35,85 65,85 65,80 L65,70 Z" />
          <line x1="50" y1="85" x2="50" y2="95" />
          <line x1="30" y1="95" x2="70" y2="95" />
        </g>
        <g className="trophy-sparkles">
          {/* Sparkles */}
          <path d="M50,5 L50,15" />
          <path d="M25,15 L30,20" />
          <path d="M75,15 L70,20" />
        </g>
      </svg>
    </div>
  );
};

export default AnimatedTrophy;